import { Map } from 'immutable';

const takeFromViewIfExists: string[] = ['placeholder', 'toolbarButtons'];

export const mergeViewProperties = (
	properties: Map<string, any> = Map(),
	viewProperties: Map<string, any> = Map()
) => {
	let newProperties = properties;

	if (viewProperties.count()) {
		newProperties = properties.mergeDeep(viewProperties);

		takeFromViewIfExists.forEach(property => {
			if (viewProperties.has(property)) {
				newProperties = newProperties.set(property, viewProperties.get(property));
			}
		});
	}

	return newProperties;
};
